import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/Card';
import { calculatorTools } from '../tools/calculatorTools';

const CALCULATOR_ROUTES = {
  'cable-limiting-temperature': '/tenant/mobile/calculators/cable-limiting-temperature',
  'max-zs-values': '/tenant/mobile/calculators/max-zs-values',
  'cable-size': '/tenant/mobile/calculators/cable-size',
  'kva-calc': '/tenant/mobile/calculators/kva-calc',
  'ohms-law': '/tenant/mobile/calculators/ohms-law',
  'pfc-calc': '/tenant/mobile/calculators/pfc-calc',
  'rfc-line-cpc-ratio': '/tenant/mobile/calculators/rfc-line-cpc-ratio',
  'rfc-r1-r2-converter': '/tenant/mobile/calculators/rfc-r1-r2-converter',
  'voltage-drop-ac': '/tenant/mobile/calculators/voltage-drop-ac',
  'voltage-drop-dc': '/tenant/mobile/calculators/voltage-drop-dc',
  'watt-amps-volts': '/tenant/mobile/calculators/watt-amps-volts',
};

export default function MobileCalculators() {
  const navigate = useNavigate();
  return (
    <div className="px-4 py-6 pb-8">
      {/* Header with back link */}
      <div className="flex items-center gap-3 mb-6">
        <Link
          to="/tenant/mobile"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 -ml-1"
          aria-label="Back to home"
        >
          <ChevronLeft className="h-5 w-5" />
        </Link>
        <div className="min-w-0 flex-1">
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            Calculators
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Electrical calculation tools
          </p>
        </div>
      </div>

      {/* Calculator list - single column, large touch targets */}
      <div className="space-y-3">
        {calculatorTools.map((tool) => {
          const Icon = tool.icon;
          return (
            <button
              key={tool.id}
              type="button"
              onClick={() => {
                const path = CALCULATOR_ROUTES[tool.id];
                if (path) {
                  navigate(path);
                }
              }}
              className="w-full text-left"
            >
              <Card className="min-h-[72px] flex items-center active:opacity-90 transition-opacity bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
                <CardContent className="flex items-center gap-4 p-4 w-full">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400">
                    <Icon size={24} strokeWidth={2} aria-hidden />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-base font-medium text-gray-900 dark:text-gray-100">
                      {tool.title}
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
                      {tool.description}
                    </p>
                  </div>
                  <span className="sr-only">Open {tool.title}</span>
                </CardContent>
              </Card>
            </button>
          );
        })}
      </div>
    </div>
  );
}
